export const ANALYTICS_EVENTS = Object.freeze({
  SERVICE_VIEWED: 'service_viewed',
  SERVICE_CTA_CLICKED: 'service_cta_clicked',
  RESOURCE_VIEWED: 'resource_viewed',
  CASE_STUDY_VIEWED: 'case_study_viewed',
  BOOK_CALL_STARTED: 'book_call_started',
  BOOK_CALL_SUBMITTED: 'book_call_submitted',
  CONTACT_STARTED: 'contact_started',
  CONTACT_SUBMITTED: 'contact_submitted',
  FREE_AUDIT_STARTED: 'free_audit_started',
  FREE_AUDIT_SUBMITTED: 'free_audit_submitted',
});

const ALLOWED_FIELDS = new Set([
  'route',
  'serviceSlug',
  'resourceSlug',
  'caseStudySlug',
  'ctaLocation',
  'referrerCategory',
  'utmCampaign',
]);

const ALLOWED_EVENTS = new Set(Object.values(ANALYTICS_EVENTS));

const getReferrerCategory = () => {
  if (typeof document === 'undefined') return 'unknown';
  if (!document.referrer) return 'direct';

  try {
    const referrer = new URL(document.referrer);
    const current = new URL(window.location.href);
    return referrer.hostname === current.hostname ? 'internal' : 'external';
  } catch (error) {
    return 'unknown';
  }
};

const getUtmCampaign = () => {
  if (typeof window === 'undefined') return '';
  return new URLSearchParams(window.location.search).get('utm_campaign') || '';
};

export const buildAnalyticsPayload = (payload = {}) => {
  const safePayload = {};
  for (const [key, value] of Object.entries(payload)) {
    if (ALLOWED_FIELDS.has(key) && value !== undefined && value !== null) {
      safePayload[key] = String(value);
    }
  }
  return safePayload;
};

export const trackAnalyticsEvent = (eventName, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (!ALLOWED_EVENTS.has(eventName)) return;

  const detail = {
    event: eventName,
    route: window.location.pathname,
    referrerCategory: getReferrerCategory(),
    utmCampaign: getUtmCampaign(),
    ...buildAnalyticsPayload(payload),
  };

  window.dispatchEvent(new CustomEvent('webouse_analytics_event', { detail }));

  if (process.env.REACT_APP_ANALYTICS_DEBUG === '1') {
    console.debug('[webouse analytics]', detail);
  }
};
